<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="fm-title">Contents</h1>
<p class="toc1" id="toc-preface001"><a href="#/preface001">Epigraph</a></p>
<p class="toc1" id="toc-prologue"><a href="#/prologue">Prologue</a></p>
<p class="toc1" id="toc-chapter001"><a href="#/chapter001">Year One</a></p>
<p class="toc1" id="toc-chapter002"><a href="#/chapter002">Year Two</a></p>
<p class="toc1" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">Year Four</span></p>
<p class="toc1" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">Year Five</span></p>
<p class="toc1" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">Year Six</span></p>
<p class="toc1" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">Year Seven</span></p>
<p class="toc1" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">Year Eight</span></p>
<p class="toc1" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">Year Eleven</span></p>
<p class="toc1" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">Year Twelve</span></p>
<p class="toc1" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">Year Twenty-four</span></p>
<p class="toc2" id="toc-pre"><span href="#/pre" title="Link target outside of Sample">Preview: <i>Worlds Enough and Time</i></span></p>
<p class="toc1" id="toc-Authorbio"><span href="#/Authorbio" title="Link target outside of Sample">A Biography of Joe Haldeman</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?116b80b6